const Form023PICSEN = {
    picsTitle: "Personal Information Collection Statement",
    subtitleList: [
        { text: "Purpose of Collection" },
        { text: "Classes of Transferees" },
        { text: "Access to Personal Data" },
    ],
    symbolStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
    ],
    firstStep: [
        {
            text: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        },
        {
            text: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the form.",
        },
        {
            text: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        },
        {
            text: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to the Controlling Officer (Data Protection) at 15/F, Wu Chung House, 213 Queen's Road East, Wan Chai, Hong Kong or email to <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>.",
        },
    ],
    secondStep: [
        {
            text: "Activities relating to the processing, authentication and counter-checking of employment-related matters including appointments, training and career developments, remuneration and benefits, staff relation, communications and compliance with procedures;",
        },
        {
            text: "Activities relating to matching of the personal data with the database of relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of employment-related matters mentioned in (a) above; ",
        },
        {
            text: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB, and ",
        },
        {
            text: "Activities relating to compilation of statistics, research and Government publications.",
        },
    ],
    thirdStep: [
        {
            text: "other Government bureaux and departments for the purposes mentioned in paragraph 1 above;",
        },
        {
            text: "personnel, agent, service provider or organisations engaged by EDB to provide services or advice for the purposes mentioned in paragraph 1 above;",
        },
        {
            text: "where you have given your prescribed consent to such disclosure; and",
        },
        {
            text: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
    ],
};
export default Form023PICSEN;
